module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	'use strict';

	fox.registerWidget('User_PasswordRecovery_Base', {

		configure: function(options) {

			this.registerOptions('', {
				errorContainer: '#recovery-message',
				handleWom: {
					submit: {
						widget: '#form',
						event: 'submit',
						callback: 'submit'
					}
				},
				handleDom: {
					focus: {
						event: 'focus',
						target: 'input',
						callback: function(elm) {
							this.toggleInputErrorState(false, elm.name);
						}.bind(this)
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function() {
			this.callParent('running', arguments);

			this._inProgress = false;
		},

		formInvalidate: function(infos, form, ev) {
			infos.forEach(function(err) {
				this.toggleInputErrorState((err.result === false), err.field, err.message);
			}.bind(this));
		},

		toggleInputErrorState: function(state, field, msg) {
			var inp = this.dom1('[name="' + field + '"]');

			fox.dom[(state === true ? 'addClass' : 'removeClass')]('error', inp.parentNode);
			this.toggleErrorBlock(state, msg, inp);
		},

		toggleErrorBlock: function(state, msg, inp) {
			var elm = !!inp ? inp.parentNode.nextElementSibling : this.dom1(this.getOption('errorContainer'));
			if (state === false) {
				elm.innerHTML = '';

				return;
			}

			elm.innerHTML = msg;
		},

		toggleLoader: function(state) {
			var button = this.dom1('#submit-btn');
			var loader = this.dom1('#submit-btn .small-loader');

			if (!button || !loader) {
				return;
			}

			fox.dom[(state ? 'addClass' : 'removeClass')]('spin', button);
			fox.dom[(state ? 'addClass' : 'removeClass')]('spin', loader);
		},

		handleError: function(resp) {
			this._inProgress = false;

			this.toggleErrorBlock(true, resp.params.answer.reason);
			this.toggleLoader(false);
		},

		handleResponse: function(resp) {
			this._inProgress = false;

			this.toggleErrorBlock(false);
			this.toggleLoader(false);
		},

		submit: function(data) {
			if (this._inProgress === true) {
				return false;
			}

			return true;
		}


	}, 'Widget');
})(fox);


 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/main/widget/user/passwordRecovery/base.js
// module id = 141
// module chunks = 4